import React from 'react'
import './HomeAdvantagesCard.scss'

/*
  Иконки преимуществ — монохромные PNG цвета #202020 с прозрачностью, в
  тёмной теме они сливались с фоном. Рисуем их маской: сам файл задаёт
  форму, цвет приходит из токена и живёт по теме. activeCard — готовый
  React-узел с иконки другой страницы, его маской не красим.
*/
const HomeAdvantagesCard = ({ img, title, subTitle, active, activeCard }) => {
  return (
    <div className={'homeAdvantagesCard' + (active ? ' homeAdvantagesCard--center' : '')}>
      <span className="homeAdvantagesCard_badge" aria-hidden="true">
        {activeCard ? img : (
          <span
            className="homeAdvantagesCard_icon"
            style={{ '--icon': `url(${img})` }}
          />
        )}
      </span>

      <h5>{title}</h5>
      <p>{subTitle}</p>
    </div>
  )
}

export default HomeAdvantagesCard
